import { Link } from 'react-router-dom';

/**
 * Footer component with company information and links
 */
export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Descripción de Validea */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Validea</h3>
            <p className="text-gray-600 mb-4">
              Validea es una herramienta innovadora diseñada para ayudarte a validar tus ideas de negocio de manera eficiente y efectiva, permitiéndote 
              tomar decisiones basadas en datos reales del mercado.
            </p>
          </div>

          {/* Enlaces Rápidos */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Enlaces Rápidos</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-600 hover:text-primary-600 transition-colors">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-600 hover:text-primary-600 transition-colors">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>

          {/* Contacto */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4">¿Tienes preguntas?</h3>
            <p className="text-gray-600 mb-2">Contáctanos.</p>
            <a 
              href="mailto:validea@alineatec.com" 
              className="text-primary-600 hover:text-primary-700 transition-colors"
            >
              validea@alineatec.com
            </a>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <p className="text-center text-gray-600">
            © 2025 Validea. Todos los derechos reservados. 
            <span className="block sm:inline"> Desarrollado por {' '}
              <a 
                href="https://alineatec.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-primary-600 hover:text-primary-700 transition-colors"
              >
                AlineaTec
              </a>
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
} 